// extracted by mini-css-extract-plugin
module.exports = {"container":"RecentlyViewed_container__MSkUA","title":"RecentlyViewed_title__HB1is","wishlistButton":"RecentlyViewed_wishlistButton__Qldgb"};